<template>
	<div class="vertical-panel">
		<div v-if="showHeader" class="vertical-panel-header">
			<slot name="header" />
		</div>
		<div v-if="showSubHeader" class="vertical-panel-sub-header">
			<slot name="sub-header" />
		</div>
		<div class="vertical-panel-content">
			<slot />
		</div>
		<slot name="dialogs" />
	</div>
</template>

<script>
export default {
	name: 'TVerticalPanel',
	props: { hideSubHeader: { type:Boolean,default:false } },
	computed: {
		showHeader() {
			return Boolean(this.$slots['header']);
		},
		showSubHeader() {
			return Boolean(this.$slots['sub-header']) && !this.hideSubHeader;
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
.vertical-panel {
	height: 100%;
	display: flex;
	flex-direction: column;
	position: relative;
	&-header {
		z-index: 3;
	}

	&-sub-header {
		z-index: 2;
	}

	&-content {
		z-index: 1;
		overflow-y: auto;
		position: relative;
		height: 100%;
	}

	&-header, &-sub-header {
		height: 50px;
		min-height: 50px;
		max-height: 50px;
		background: white;
		box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
	}
}


</style>
